export const LCP_SHELL_ID = 'yovo-lcp-shell';
export const LCP_CARD_ID = 'yovo-lcp-card';
export const LCP_SHELL_ROOT_CLASS = 'yovo-home-shell';
export const LCP_SHELL_HOTEL_CLASS = 'yovo-lcp-hotel';

/** Homepage tab URLs. The inline script in public/index.html must list the same paths. */
const LCP_SHELL_PATHS = new Set(['/', '/flights', '/hotels', '/trains']);

/** The static shell covers a full load of the homepage until React has painted. */
export function isLcpShellPath(pathname) {
  const path = String(pathname || '/').replace(/\/+$/, '') || '/';
  return LCP_SHELL_PATHS.has(path);
}

/**
 * Drop the static header, the search-card skeleton, and the pull-up class.
 * All three go in one turn so the real header and card stay where they are.
 */
export function removeLcpShell(doc = document) {
  doc.getElementById(LCP_CARD_ID)?.remove();
  doc.getElementById(LCP_SHELL_ID)?.remove();
  doc.documentElement.classList.remove(LCP_SHELL_ROOT_CLASS, LCP_SHELL_HOTEL_CLASS);
}
